<div [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.default">
	<div [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.heading.default">
		<h3 [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.heading.header.default">
			{{label}}
		</h3>
	</div>
	<app-d-form-input [formGroup]="appFormGroup" [formElements]="formElements" [options]="options" (change)="onElementInputChange()">
		</app-d-form-input>
	<button *ngIf="testing" (click)="onTest()">test- validity:{{appFormGroup.valid}}</button>
</div>
